import React from "react";
import { m } from "kremling";
import { currency } from "@helpers";

type CurrencyCellProps = {
  value: number | string;
  isDisabled?: boolean;
};

export function CurrencyCell({ value, isDisabled }: CurrencyCellProps) {
  const cellText = currency(value);
  return (
    <div
      className={m("cp-data-table-cell-disabled", isDisabled)}
      title={cellText}
    >
      {cellText}
    </div>
  );
}
